export const init_q = {
    q: '',
    brands: [],
    categories: [],
    subcategories: [],
    models: [],
    page: 0,
    order: null,
}
// Se genera una copia del objeto
export let q = {
    q: '',
    brands: [],
    categories: [],
    subcategories: [],
    models: [],
    page: 0,
    order: null,
}

export function printProduct(p, isNext) {
    const user = window.appData?.user || null || null

    const has_price = !!p.products[0]
    const hasDiscount = has_price && p.products[0].priceDiscount !== p.products[0].priceList
    const hasPublicDiscount = has_price && p.products[0].pricePublicDiscount !== p.products[0].pricePublic

    let price = ``
    if (has_price && p.products[0]?.priceDiscount) price = `
      <p class="price__discount" data-format-price${isNext ? `-` + q.page : ''}='true' data-price="priceDiscount">$
        ${(has_price && p.products[0].priceDiscount) || 0}
      </p>
    `

    let old_price = ``
    if (p.products[0]?.priceList) old_price = `
      <p class="price" data-format-price${isNext ? `-` + q.page : ''}='true'  data-price="priceList">$
        ${p.products[0]?.priceList}
      </p>
    `

    let iva_price = ''
    if (has_price && p.products[0]?.pricePublicDiscount) iva_price = `
      <p class="price__discount" data-format-price${isNext ? `-` + q.page : ''}='true' data-price="pricePublicDiscount">$
        ${(p.products[0]?.pricePublicDiscount * 1.21) || 0}
      </p>
    `

    let old_iva_price = ''
    if (p.products[0]?.pricePublic) old_iva_price = `
      <p class="price" data-format-price${isNext ? `-` + q.page : ''}='true' data-price="pricePublic">$
        ${p.products[0]?.pricePublic * 1.21}
      </p>
    `

    const src = p.images?.[0]?.link ? p.images[0].link : `https://servi-compras.com.ar/uploads/${p.images?.[0]?.name}`
    const img_html = `
        <img loading="lazy" src="${src}" alt="" onerror="this.src='/img/noImage.jpg'">
    `

    return `
        <div data-id="${p.id}" data-url="/product/view/${p.id}" class="product">
            <div class="left">
                <div class="product-top">
                    ${img_html}
                </div>
                <a href="/product/view/${p.id}" class="product__details"> + Detalles </a>
                ${user ? `
                <a href="/product/view/${p.id}" class="product__data" style="background: #ddd; color: #000">
                    ${user && (iva_price || old_iva_price || old_price || price) ? `
                        <div class="prices">
                            <div class="price-container" data-name="list__prices">
                                <div class="prices__container">
                                    ${hasDiscount ? old_price : ''}
                                    ${price || ''}
                                </div>
                                <span style="font-size: .9em; display: block;">P. Lista (sin IVA)</span>
                            </div>

                            <div class="price-container">
                                <div class="prices__container" style="margin: 1em 0 0 0">
                                    ${hasPublicDiscount ? old_iva_price : ''}
                                    ${iva_price}
                                </div>
                                <span style="font-size: .9em; display: block;">PVP (IVA incluido)</span>
                            </div>
                        </div>
                    `: ''}
                </a>
                `: ""}
            </div>

            <form data-name="product-form" data-id="${p.id}" data-code="${p.code}" class="right">
                <div class="header">
                    <p class="product__name">${p['title']}</p>
                    <p class="product__sku">SKU: ${p['code']}</p>
                </div>
                ${user ? `
                    <div class="sizes">
                        ${p.products.map((price) => price.stock > 0 ? `
                            <div class="size-container" data-price-id="${price.id}" data-stock="${price.stock}" data-sku="${price.code}">
                                <p class="size">${price.size}</p>
                                <div class="size-right">
                                    <button type="button" class="minus"><i class="fa fa-minus"></i></button>
                                    <input type="text" value="" placeholder="0" />
                                    <button type="button" class="plus"><i class="fa fa-plus"></i></button>
                                </div>
                            </div>
                        `: price.stock == -1 ? `
                            <div class="size-container" data-price-id="${price.id}" data-stock="${price.stock}" data-sku="${price.code}">
                                <p class="size">${price.size}</p>
                                <div class="size-right">
					Consulte con su vendedor
                                </div>
                            </div>
                        `: '').join('')}
                    </div>
                    <button type="submit">Añadir al carrito</button>
                `: ""}
            </form>
        </div>
    `
}
